import { Fragment } from 'react';
import { element } from '../../core/elements';
import { AxisBottomTick } from '../axis/axis/AxisBottom';
import { useAxisTicks } from '../axis/axis/useAxisTicks';
import Orientation from '../axis/constants/orientation';
import { Point } from '../point';
import { coerceNumber } from '../scale';
import getScaleBandwidth from './utils/getScaleBandwidth';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function GridColumns(_ref) {
  let {
    top = 0,
    left = 0,
    scale,
    height,
    stroke = "var(--ds-border, lightgrey)",
    strokeWidth = 1,
    numTicks,
    lineStyle = 'solid',
    offset,
    tickValues,
    hide = false
  } = _ref;
  if (hide) return null;
  const {
    ticks
  } = useAxisTicks({
    scale,
    numTicks,
    tickValues,
    tickLength: 8,
    orientation: Orientation.bottom,
    rangePadding: undefined
  });
  const scaleOffset = (offset !== null && offset !== void 0 ? offset : 0) + getScaleBandwidth(scale) / 2;
  const tickLines = ticks.map(_ref2 => {
    var _coerceNumber;
    let {
      value,
      index
    } = _ref2;
    const x = ((_coerceNumber = coerceNumber(scale(value))) !== null && _coerceNumber !== void 0 ? _coerceNumber : 0) + scaleOffset;
    return {
      index,
      from: new Point({
        x,
        y: 0
      }),
      to: new Point({
        x,
        y: height
      })
    };
  });
  return /*#__PURE__*/_jsx("div", {
    style: {
      top: top,
      left: left,
      position: 'relative'
    },
    children: tickLines.map(_ref3 => {
      let {
        from,
        to,
        index
      } = _ref3;
      return /*#__PURE__*/_jsxs(Fragment, {
        children: [/*#__PURE__*/_jsx(AxisBottomTick, {
          from: from,
          to: to
        }), /*#__PURE__*/_jsx("div", {
          style: {
            borderLeft: `${stroke} ${lineStyle} ${strokeWidth}px`,
            height: `${to.y}px`,
            position: 'absolute',
            left: to.x
          }
        })]
      }, `grid-columns-lines-${index}-${from.toArray()}-${to.toArray()}`);
    })
  });
}
const _GridColumns = element(GridColumns);
export { _GridColumns as GridColumns };